import { render, staticRenderFns } from "./ConsentConfig.vue?vue&type=template&id=51c4eb09&scoped=true"
import script from "./ConsentConfig.vue?vue&type=script&lang=js"
export * from "./ConsentConfig.vue?vue&type=script&lang=js"
import style0 from "./ConsentConfig.vue?vue&type=style&index=0&id=51c4eb09&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c4eb09",
  null
  
)

/* custom blocks */
import block0 from "./ConsentConfig.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports